export default () => ({
  projects: [],
  projectMasters: [],
})
